import { RESET_ALL_STATES } from "../actions/actions";

import {
  PACKET_STATUS_REQUEST,
  PACKET_STATUS_SUCCESS,
  PACKET_STATUS_FAILURE,
} from "../actions/actionTypes";

const initialState = {
  isLoading: false,
  error: null,
  data: null,
};

const packetStatusReducer = (state = initialState, action) => {
  switch (action.type) {
    case PACKET_STATUS_REQUEST:
      return { ...state, isLoading: true, error: null };
    case PACKET_STATUS_SUCCESS:
      return { ...state, isLoading: false, data: action.payload };
    case PACKET_STATUS_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    case RESET_ALL_STATES:
      return initialState;
    default:
      return state;
  }
};

export default packetStatusReducer;
